var DEFAULT_LOCALE = 'en';
var SUPPORTED_LOCALES = [DEFAULT_LOCALE, 'de', 'fr'];

(function init() {
  var browserLocale = getBrowserLocale();
  var cookieLocale = getCookie('locale');
  var currentLocale = cookieLocale || DEFAULT_LOCALE;

  if (cookieLocale === null) {
    switchLocale(currentLocale, browserLocale);
  }
})();

function isLocaleSupported(locale) {
  return SUPPORTED_LOCALES.indexOf(locale) !== -1;
}

function switchLocale(fromLocale, toLocale) {
  var localeSupported = isLocaleSupported(toLocale);

  if (!localeSupported) {
    return false;
  }

  if (fromLocale !== toLocale) {
    redirectToLocale(toLocale);
  }

  return true;
}

function getBrowserLocale() {
  if (navigator.language) {
    return navigator.language.substring(0, 2);
  }

  return null;
}

function redirectToLocale(locale) {
  var url = window.location.href;
  window.location.href = url.replace('/manufacture', '/manufacture/' + locale);
}

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}
